
import i18n from "../i18n";

const initialState = {
    'booking_data': {},
    'language': localStorage.getItem("i18nextLng"),
    'company_layout': {}
    //'language': i18next.language || localStorage.getItem("i18nextLng")
};

function rootReducer(state = initialState, action) {
    let new_state = state;
    if (action.type === 'BOOKING_DATA') {
        new_state = Object.assign({}, state, {
            'booking_data': action.payload
        });
    } else if (action.type === 'CLEAR_BOOKING') {
        new_state = Object.assign({}, state, {
            'booking_data': {}
        });
    } else if (action.type === 'SAVE_USER_DATA') {
        new_state = Object.assign({}, state, {
            'user': action.payload
        });
    } else if (action.type === 'CHANGE_LANGUAGE') {
        new_state = Object.assign({}, state, {
            'language': action.payload
        });
        i18n.changeLanguage(action.payload)
    } else if (action.type === 'SAVE_COMPANY_DATA') {
        new_state = Object.assign({}, state, {
            'company': action.payload
        });
    } else if (action.type === 'SET_COMPANY_LAYOUT') {
        new_state = Object.assign({}, state, {
            'company_layout': action.payload
        });
    } else if (action.type === 'SAVE_USERS') {
        new_state = Object.assign({}, state, {
            'users': action.payload
        });
    } else if (action.type === 'TOGGLE_ALERT') {
        new_state = Object.assign({}, state, {
            'global_alert': action.payload
        });
    }
    window.sessionStorage.setItem("state", JSON.stringify(new_state))
    return new_state;
}

export default rootReducer;